import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/paymentReceipt';
const currencyTypeUrl = base_url+'api/admin/prCurrencyType';
const eventTypeUrl = base_url+'api/admin/prEventType';
const occupancyTypeUrl = base_url+'api/admin/prOccupancyType';
const paymentTypeUrl = base_url+'api/admin/prPaymentType';
const registrationCategoryTypeUrl = base_url+'api/admin/prRegistrationCategory';
const regTypeUrl = base_url+'api/admin/prRegistrationType';
const countriesUrl = base_url+'api/admin/esCountries';
const receiptIdUrl = base_url+'api/event/receiptIdGeneration';
const seriesTypeUrl = base_url+'api/admin/esSeriesType';
const conferenceEventUrl = base_url+'api/admin/conferenceEvent';
const webinarEventUrl = base_url+'api/admin/webinarEvent';

 

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const getReceiptId = async (params) => {
  try {
    const response = await api.post(receiptIdUrl, params);  // Pass params directly
    return response.data.data;
  } catch (error) {
    console.error("Error fetching receipt ID:", error);
    throw error;
  }
};
 
export const getDataById = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const getcountries = async () => {
  const response = await api.get(countriesUrl);
  return response.data.data;
};
export const getregistrationCategoryType = async () => {
  const response = await api.get(registrationCategoryTypeUrl);
  return response.data.data;
};

export const getseriesType = async (params) => {
  const whereParam = params;
  const response = await api.post(seriesTypeUrl, whereParam);
  return response.data.data;
};
export const getconferenceEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(conferenceEventUrl, whereParam);
  return response.data.data;
};

export const getwebinarEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(webinarEventUrl, whereParam);
  return response.data.data;
};
 
export const getpaymentType = async () => {
  const response = await api.get(paymentTypeUrl);
  return response.data.data;
};
export const getregType = async () => {
  const response = await api.get(regTypeUrl);
  return response.data.data;
};
export const getoccupancyType = async () => {
  const response = await api.get(occupancyTypeUrl);
  return response.data.data;
};
export const geteventType = async () => {
  const response = await api.get(eventTypeUrl);
  return response.data.data;
};
export const getcurrencyType = async () => {
  const response = await api.get(currencyTypeUrl);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};